import { useCallback } from 'react'
import { ReactComponent as ResetIcon } from 'assets/icons/reset.svg'
import IconWrapper from 'components/IconWrapper'
import { ActionButton } from 'components/PageStructure'
import useUncancelOtc from 'hooks/useUncancelOtc'
import styled from 'styled-components'
import { bodyPrimaryColor, primaryBackgroundColor } from 'styles/styleVariables'

type UncancelOtcButtonProps = {
  orderId: string
  otcProductId: string
  onUncancelled?: () => void
}

const UncancelOtcButton = ({ orderId, otcProductId, onUncancelled }: UncancelOtcButtonProps): JSX.Element => {
  const uncancelOtc = useUncancelOtc()
  const clickHandler = useCallback(() => uncancelOtc(orderId, otcProductId).then(() => onUncancelled?.()), [])
  return (
    <StyledActionButton
      data-testid="uncancel"
      icon={
        <ResetIconWrapper title="Uncancel Otc">
          <ResetIcon fill={bodyPrimaryColor} />
        </ResetIconWrapper>
      }
      onClick={clickHandler}
    />
  )
}

const ResetIconWrapper = styled(IconWrapper)`
  display: flex;
  grid-column: removeIcon;
  svg {
    fill: #999999;
  }
`

const StyledActionButton = styled(ActionButton)`
  background-color: ${primaryBackgroundColor};
  margin: 1px 0px 0px -3px;
  padding: 0 5px 0 2px;
  border-radius: 4px;
  grid-column: uncancelFill;
}
`

export default UncancelOtcButton
